(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  if (window.csDiscoveryBooking) return;
  var mode = root.getAttribute('data-cs-discovery');
  if (!mode) return;
  var explicitPage = mode === 'appointment';
  var firstViewport = Math.max(1, root.clientHeight || window.innerHeight);
  var threshold = firstViewport, media = null, forms = [], controls = [];
  var frame = 0, refreshNeeded = true, lastState = '', observer;
  var stickySelector = '.pf26-mobile-cta,.cbj-sticky,.cl26-mobile-sticky,.rp-sticky,.dn-sticky,.dn-pdp-sticky,.cs26-booking-bar';
  var explicitSelector = '[data-dn-appointment],[data-dn-viewer-appointment],[data-rp-appointment],[data-cbj-appointment],[data-cl26-appointment],[data-cs26-appointment],[data-cp-appointment],[data-cs-cta-action="appointment"],[data-pf26-cta="appointment"],[data-cbj-cta="appointment"],[data-cl26-cta="appointment"]';
  var locks = new WeakMap();
  function all(selector, scope) { return Array.from((scope || doc).querySelectorAll(selector)); }
  function scrollY() { return window.scrollY || window.pageYOffset || 0; }
  function headerHeight() {
    var header = doc.querySelector('.shopify-section--header');
    return header ? header.getBoundingClientRect().height : 0;
  }
  function formSection(form) { return form.closest('.shopify-section') || form; }
  function hasArea(node) {
    if (!node || !node.isConnected) return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }
  function localTarget(link) {
    try {
      var url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return null;
      return doc.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch (_) { return null; }
  }
  function containsForm(node) {
    return node && (node.matches('form[data-cs-lead-form]') || node.closest('form[data-cs-lead-form]') || node.querySelector('form[data-cs-lead-form]'));
  }
  function appointmentLink(link) {
    if (link.matches(explicitSelector)) return true;
    if (link.tagName !== 'A') return false;
    var target = localTarget(link);
    if (containsForm(target)) return true;
    try { return /\/pages\/programeaza\/?$/.test(new URL(link.getAttribute('href'), location.href).pathname); }
    catch (_) { return false; }
  }
  function exempt(control) {
    return control.closest('form,dialog,[role="dialog"],[data-cs-discovery-exempt]') !== null;
  }
  function lock(control, value) {
    if (!explicitPage && (!control.closest(stickySelector) || control.matches(stickySelector))) {
      control.setAttribute('data-cs-discovery-motion', '');
    }
    if (value) {
      if (!locks.has(control)) locks.set(control, control.hasAttribute('inert'));
      control.setAttribute('data-cs-discovery-locked', '');
      control.setAttribute('inert', '');
    } else {
      control.removeAttribute('data-cs-discovery-locked');
      if (locks.has(control)) {
        if (!locks.get(control)) control.removeAttribute('inert');
        locks.delete(control);
      }
    }
  }
  function fixRoutes() {
    var invitation = doc.querySelector('[data-cs-invitation]');
    var localForm = forms.find(hasArea);
    if (invitation) {
      var fallback = invitation.getAttribute('data-cs-invitation-fallback') || invitation.getAttribute('href');
      invitation.setAttribute('href', localForm && localForm.id ? '#' + localForm.id : fallback);
    }
    if (localForm && doc.querySelector('[data-cc-root],.dcm') && !doc.getElementById('programare')) {
      var alias = doc.createElement('span');
      alias.id = 'programare';
      alias.className = 'cs-anchor-marker';
      alias.setAttribute('aria-hidden', 'true');
      localForm.insertBefore(alias, localForm.firstChild);
    }
  }
  function measureThreshold() {
    threshold = firstViewport;
    var main = doc.getElementById('main');
    if (!main) return;
    if (!media || !media.isConnected || !hasArea(media)) {
      media = all('img,video', main).find(function (node) {
        if (node.closest('form,dialog,template,.shopify-section--footer,[aria-hidden="true"]:not(video)')) return false;
        var r = node.getBoundingClientRect();
        return r.width >= 160 && r.height >= 160 && getComputedStyle(node).visibility !== 'hidden';
      }) || null;
    }
    if (media) {
      var rect = media.getBoundingClientRect();
      var discoveryEnd = rect.top + scrollY() + Math.min(rect.height * 0.65, firstViewport * 0.75);
      threshold = Math.max(firstViewport, discoveryEnd - headerHeight());
    }
    root.style.setProperty('--cs-discovery-threshold', Math.ceil(threshold) + 'px');
  }
  function inlineProductReady(control, y) {
    var donnaInline = control.matches('[data-dn-pdp] [data-dn-cta-block] [data-dn-appointment]');
    var menInline = control.matches('.cs-product-appointment__link, [data-atelier-action] [data-booking]');
    if (!donnaInline && !menInline) return false;
    if (control.closest(stickySelector) || control.closest('[data-fw26-pdp-sticky]') || y < Math.min(160, firstViewport * 0.25)) return false;
    if (control.closest('.c-gift-product-layout')) return true;
    var productRoot = donnaInline ? control.closest('[data-dn-pdp]') : control.closest('#main');
    if (!hasArea(media) || !productRoot || !productRoot.contains(media)) return false;
    var block = donnaInline ? control.closest('[data-dn-cta-block]') : control.closest('.cs-product-appointment, [data-atelier-action]');
    var mediaRect = media.getBoundingClientRect(), blockRect = block.getBoundingClientRect();
    if (mediaRect.top >= blockRect.bottom) return false;
    var exploredEdge = mediaRect.top + Math.min(mediaRect.height * 0.65, firstViewport * 0.75);
    return exploredEdge <= (root.clientHeight || window.innerHeight) - headerHeight();
  }
  function formAt(y) {
    var current = scrollY(), vh = root.clientHeight || window.innerHeight, top = headerHeight();
    return forms.some(function (form) {
      var area = formSection(form), rect = area.getBoundingClientRect();
      return rect.height > 0 && rect.bottom + current > y + top && rect.top + current < y + vh;
    });
  }
  function invitationAt(y) {
    return (explicitPage || y >= threshold) && !formAt(y) && !all('dialog,[role="dialog"][aria-modal="true"]').some(function (dialog) {
      // Shopify drawers retain aria-modal while closed; their open property is authoritative.
      if ('open' in dialog) return dialog.hasAttribute('open');
      if (dialog.closest('[hidden],[inert],[aria-hidden="true"]') || !hasArea(dialog)) return false;
      var style = getComputedStyle(dialog);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });
  }
  function revealInvitation(show) {
    var invitation = doc.querySelector('[data-cs-invitation]');
    root.classList.toggle('cs-invitation-revealed', Boolean(invitation && show));
    if (!invitation) return;
    if (!show && invitation.contains(doc.activeElement)) {
      var logo = doc.querySelector('.header__logo a,.header__logo');
      if (logo && typeof logo.focus === 'function') logo.focus({ preventScroll: true });
    }
    invitation.toggleAttribute('inert', !show);
    if (show) invitation.removeAttribute('aria-hidden');
    else invitation.setAttribute('aria-hidden', 'true');
  }
  function scan() {
    forms = all('form[data-cs-lead-form]');
    fixRoutes();
    controls = all(stickySelector);
    var main = doc.getElementById('main');
    if (main) all('a[href],button', main).forEach(function (control) {
      if (!exempt(control) && appointmentLink(control) && !controls.includes(control)) controls.push(control);
    });
    measureThreshold();
  }
  function check() {
    frame = 0;
    if (refreshNeeded) { refreshNeeded = false; scan(); }
    var y = scrollY(), allowed = explicitPage || y >= threshold, formVisible = formAt(y);
    root.setAttribute('data-cs-discovery', explicitPage ? 'appointment' : allowed ? 'ready' : 'pending');
    controls.forEach(function (control) {
      if (!control.isConnected) return;
      var sticky = control.matches(stickySelector);
      var inlineReady = inlineProductReady(control, y);
      control.toggleAttribute('data-cs-discovery-inline-ready', inlineReady);
      lock(control, !explicitPage && ((!allowed && !inlineReady) || (sticky && formVisible)));
    });
    revealInvitation(invitationAt(y));
    var state = [allowed, formVisible, root.classList.contains('cs-invitation-revealed'), Math.ceil(threshold)].join(':');
    if (state !== lastState) { lastState = state; doc.dispatchEvent(new CustomEvent('cs:discovery-change')); }
  }
  function schedule(refresh) {
    if (refresh === true) refreshNeeded = true;
    if (!frame) frame = requestAnimationFrame(check);
  }
  function refresh() { schedule(true); }
  window.csDiscoveryBooking = { invitationAt: invitationAt, refresh: refresh, threshold: function () { return threshold; } };
  function start() {
    check();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('orientationchange', function () { firstViewport = Math.max(1, root.clientHeight || window.innerHeight); refresh(); });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('hashchange', refresh);
    doc.addEventListener('shopify:section:load', refresh);
    doc.addEventListener('shopify:section:unload', refresh);
    doc.addEventListener('shopify:section:reorder', refresh);
    doc.addEventListener('toggle', refresh, true);
    doc.addEventListener('close', refresh, true);
    doc.addEventListener('dialog:before-show', refresh, true);
    doc.addEventListener('dialog:after-show', refresh, true);
    doc.addEventListener('dialog:after-hide', refresh, true);
    doc.addEventListener('load', function (event) { if (event.target.matches && event.target.matches('#main img,#main video')) refresh(); }, true);
    if (window.ResizeObserver) {
      var resize = new ResizeObserver(refresh), main = doc.getElementById('main');
      if (main) resize.observe(main);
    }
    if (window.MutationObserver) {
      observer = new MutationObserver(function (records) {
        if (records.some(function (record) { return record.type === 'childList'; })) refresh();
      });
      var content = doc.getElementById('main');
      if (content) observer.observe(content, { childList: true, subtree: true });
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

